import { CrudService } from '../base/CrudService';
export class ProjectPortfolioService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ProjectPortfolioService.DEFAULT_SERVICE_PATH,
            basePath: ProjectPortfolioService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // Standard CRUD inherited from CrudService.
    /** GET /api/project-portfolios/{id}/members */
    async getMembers(portfolioId) {
        const response = await this.getMembersRaw(portfolioId);
        return response.data ?? [];
    }
    getMembersRaw(portfolioId) {
        return this.http.get(this.buildUrl(`${portfolioId}/members`));
    }
    /** POST /api/project-portfolios/{id}/members/{projectId} */
    async addMember(portfolioId, projectId) {
        const response = await this.addMemberRaw(portfolioId, projectId);
        return response.data ?? null;
    }
    addMemberRaw(portfolioId, projectId) {
        return this.http.post(this.buildUrl(`${portfolioId}/members/${projectId}`), {});
    }
    /** DELETE /api/project-portfolios/{id}/members/{projectId} */
    removeMember(portfolioId, projectId) {
        return this.http.delete(this.buildUrl(`${portfolioId}/members/${projectId}`));
    }
    /** GET /api/project-portfolios/{id}/rollup */
    async getRollup(portfolioId) {
        const response = await this.getRollupRaw(portfolioId);
        return response.data ?? null;
    }
    getRollupRaw(portfolioId) {
        return this.http.get(this.buildUrl(`${portfolioId}/rollup`));
    }
}
ProjectPortfolioService.DEFAULT_SERVICE_PATH = 'projects';
ProjectPortfolioService.BASE_PATH = 'api/project-portfolios';
//# sourceMappingURL=ProjectPortfolioService.js.map